import { PlatformService } from 'src/core/common/domain/platform/platform.service';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { Injectable } from '@angular/core';
import { StorableService } from 'src/core/storage/domain/storable-service';
import { Initializable } from 'src/core/common/domain/initializer/initializable';
import { BehaviorSubject, Observable } from 'rxjs';
import { Storage } from 'src/core/storage/domain/storage';
import { Nullable } from 'src/core/common/domain/types/types';

@Injectable({
  providedIn: 'root',
})
export class DeviceService implements StorableService, Initializable {
  private readySubject = new BehaviorSubject<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  ready$: Observable<boolean> = this.readySubject.asObservable();
  private readonly KEY_DEVICE_UUID = 'device.uuid';

  private deviceUuid: Nullable<string> = null;

  constructor(
    private readonly platformService: PlatformService,
    private storage: Storage,
    private readonly device: Device
  ) {}

  async init(): Promise<void> {
    await this.initFromStorage();

    this.readySubject.next(true);
  }

  async clear(): Promise<void> {
    // we do not clear stored uuid
  }

  private async initFromStorage(): Promise<void> {
    const storedDeviceUuid = await this.storage.get(this.KEY_DEVICE_UUID);

    if (storedDeviceUuid && storedDeviceUuid.trim() !== '') {
      this.deviceUuid = storedDeviceUuid;
    } else {
      await this.reset();
    }
  }

  getUuid(): string {
    return this.deviceUuid;
  }

  async setUuid(uuid: string) {
    this.deviceUuid = uuid;
    await this.storage.set(this.KEY_DEVICE_UUID, uuid);
  }

  getInitialUuid(): string {
    if (!this.platformService.isCordova()) {
      return 'unknown';
    }

    return this.device.uuid;
  }

  getModel(): string {
    if (!this.platformService.isCordova()) {
      return 'unknown';
    }

    return this.device.model;
  }

  getManufacturer(): string {
    if (!this.platformService.isCordova()) {
      return 'unknown';
    }

    return this.device.manufacturer;
  }

  async reset() {
    await this.setUuid(this.getInitialUuid());
  }
}
